document.addEventListener("DOMContentLoaded", function() {

  function applyMobileMenuFont() {
    const menuItems = document.querySelectorAll('.menu-drawer__menu-item-text, .menu-drawer_menu-item-text');
    menuItems.forEach(item => {
      item.style.fontFamily = "'CustomHeading', sans-serif";
      item.style.textTransform = "none";
      item.style.fontWeight = "400";
      item.style.fontStyle = "normal";
    });
  }

  // Apply on page load
  applyMobileMenuFont();

  // Reapply whenever drawer opens
  const drawerButtons = document.querySelectorAll('.header-drawer-toggle, .mobile-menu-button');
  drawerButtons.forEach(button => {
    button.addEventListener('click', function() {
      setTimeout(applyMobileMenuFont, 50); // allow items to render
    });
  });

  // Watch for dynamic menu changes
  const observer = new MutationObserver(applyMobileMenuFont);
  observer.observe(document.body, { childList: true, subtree: true });
});